define(function (require) {
    var $ = require('jquery');

    $('select.auto-form-submit').change(function () {
        $(this).closest("form").submit();
    });

    var $ssoForm = $('form.sso-auto-form-submit:first');

    if ($ssoForm.length > 0) {
        $ssoForm.submit();
    }

});